import React from "react";
import { styled } from "../../stitches.config";
import { bodyLarge } from "../commonStyles/Fonts";

import BridLogo from "../assets/logos/natemat/brid-logo.svg";

interface AtavistBridInfoProps {
  href: string;
}

export const AtavistBridInfo: React.FC<AtavistBridInfoProps> = ({ href }) => {
  return (
    <AtavistBridInfoWrapper>
      <BridInfo className={bodyLarge()}>
        <img src={BridLogo} />
        <p>
          Poniższy materiał został zrealizowany w ramach BRID - nowego projektu
          Grupy naTemat. Temat artykułu został najpierw wybrany w głosowaniu na
          stronie głównej naTemat.pl, a następnie czytelnicy wsparli nas
          finansowo w jego realizacji. Kolejne głosowania oraz projekty do
          wsparcia zawsze znajdziesz na brid.natemat.pl.
        </p>
        <div>
          <p>Dziękujemy, że z nami jesteście!</p>
          <a href={href}>Zobacz video czym jest BRID</a>
        </div>
      </BridInfo>
    </AtavistBridInfoWrapper>
  );
};

const AtavistBridInfoWrapper = styled("div", {
  maxWidth: "840px",
  width: "100%",
  background: "$grayscale0Fixed",
  "@bp4": {
    margin: "88px auto 80px auto",
  },
  img: {
    marginBottom: "8px",
  },
});

const BridInfo = styled("div", {
  padding: "32px 24px 42px 24px",
  borderBottom: "2px solid #f5f5f5",
  position: "relative",
  "@bp4": {
    padding: "48px 108px 40px 48px",
  },
  div: {
    "@bp4": {
      display: "flex",
      alignItems: "center",
    },
    p: {
      marginBottom: 0,
      "@bp4": {
        marginBottom: "16px",
      },
    },
    a: {
      color: "$primary",
      "@bp4": {
        marginLeft: "12px",
      },
    },
  },
});

export default AtavistBridInfo;
